(function(window){

	var HolidaySnow = function(){

		var _TEMPLATE = '<div class="holiday-snow"></div>';
		var _SNOW_DELAY = 300;

		var _construct = function() {

		};

		var initHomepageSnow = function() {
			$('body').append(_TEMPLATE);
			setTimeout(function () {
				$('.holiday-snow').addClass('holiday-snow-active')
			}, _SNOW_DELAY);
		};

		var isSnowCompatable = function() {
			// if IE == 11 or not IE
			if (getInternetExplorerVersion() === -1 || getInternetExplorerVersion() === 11) {
				return true;
			}
			return false;
		};

		var initEvents = function() {
			// if pointer events is not compatable
			// clicking on snow will remove it
			$('.holiday-snow').on('click', function() {
				$(this).remove();
			});
		};

		function getInternetExplorerVersion() {
			var ua;
			var re;
			var rv = -1;

			if (navigator.appName == 'Microsoft Internet Explorer') {
				ua = navigator.userAgent;
				re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
				if (re.exec(ua) !== null)
					rv = parseFloat( RegExp.$1 );
			} else if (navigator.appName == 'Netscape') {
				ua = navigator.userAgent;
				re  = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
				if (re.exec(ua) !== null)
					rv = parseFloat( RegExp.$1 );
			}

			return rv
		};

		this.initHomepageSnow = initHomepageSnow;
		this.isSnowCompatable = isSnowCompatable;
		this.initEvents = initEvents;

	}

	/* -------------------------------------------------------------------------- */

	$(document).ready(function(){
		try {
			var holidaySnow = new HolidaySnow();
			if (holidaySnow.isSnowCompatable()) {
				//holidaySnow.initHomepageSnow();
				//holidaySnow.initEvents();
			}
		} catch(e) {
		}
	});



})(window);
